import styled from '@emotion/styled'
import { getPxAsRem } from 'shared/utils'

export const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`

export const popupButtonStyles = {
    width: getPxAsRem(250),
    background: 'none',
    backgroundColor: 'transparent',
    padding: '0',
    cursor: 'pointer',
    fontsize: getPxAsRem(16),
    color: '#fff',
    fontWeight: 'bold',
    textTransform: 'none',
    border: '#fff 1px solid',
    borderRadius: '4px',
    boxShadow: 'none',
}
